<template lang="pug">
  .planInfoCard.infoInsurance
    .infoInsurance__head
      h2.infoInsurance__title {{ title }}

    ol.infoInsurance__listItems
      li.infoInsurance__listItems__item(v-for="(item, index) in product.infoInsurance" :key="index")

        template(v-if="/text|listTexts/.test(item.type)")
          .infoInsurance__listItems__icon
            cp-icon(:path="`/icons/${item.icon}.svg`")

          .infoInsurance__listItems__wrapper
            span.infoInsurance__listItems__label {{ item.label }}

            span.infoInsurance__listItems__text(v-if="item.type === 'text'")
              | #[strong(v-html="item.text")]
              | #[span(v-if="item.tag") {{ item.tag }}]

            ol.infoInsurance__listItems__list(v-else-if="item.type === 'listTexts'")
              li(
                v-if="item.text"
                v-for="(item, index) in item.listTexts"
                :key="index"
              )
                span.infoInsurance__listItems__text
                  | #[strong {{ item.text }}]
                  | #[span(v-if="item.tag") {{ item.tag }}]

        template(v-else-if="item.type === 'line'")
          hr.infoInsurance__line

        template(v-else-if="item.type === 'button'")
          a.infoInsurance__listItems__btn(:href="item.link" :target="item.target") {{ item.label }}
</template>
<script>
import { mapState } from 'vuex'

import cpIcon from '@/components/atoms/Icon'

export default {
  name: 'InfoInsurance',
  components: {
    cpIcon
  },
  data () {
    return {
      titleList: {
        checkout: 'Resumo da compra',
        funcionario: 'Resumo'
      }
    }
  },
  computed: {
    ...mapState(['product', 'plan']),
    title () {
      return this.titleList[process.env.VUE_APP_JOURNEY_NAME]
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .infoInsurance {
    &__head {
      display: flex;
      justify-content: space-between;
      margin-bottom: 32px;

      img {
        margin-top: -10px;
      }
    }

    &__line {
      width: 100%;
      border: none;
      border-top: 1px solid rgba(#bdc2c6, 0.3);
    }

    &__listItems {

      &__icon {
        background-color: #1a71b417;
        border-radius: 50%;
        height: 48px;
        margin-right: 16px;
        min-width: 48px;
        width: 48px;
        display: flex;

        img {
          height: 24px;
          margin: auto;
          width: 24px;
        }
      }

      &__item {
        display: flex;

        &:not(:last-child) {
          margin-bottom: 24px;
        }
      }

      &__wrapper {
        display: flex;
        flex-flow: column;
        justify-content: center;
        font-family: $rubik-font-family;
      }

      &__label {
        color: #595959;
        display: block;
        font-size: 14px;
        margin-bottom: 2px;
      }

      &__text {
        font-size: 16px;
        line-height: 1.38;

        span {
          color: #595959;
          font-size: 14px;
          margin-left: 4px;
        }
      }

      &__list {
        li {
          display: inline-block;
          margin-bottom: 2px;
          min-width: 132px;

          @media screen and (max-width: 767px) {
            margin-right: 20px;
          }

          @media screen and (min-width: 768px) {
            &:nth-child(odd) {
              margin-right: 20px;
            }
          }
        }
      }

      &__btn {
        border: solid 1px #1A71B4;
        border-radius: 20px;
        color: #373739;
        font-family: $oscine-font-family;
        font-size: 14px;
        font-weight: bold;
        padding: 11px;
        text-align: center;
        transition: background-color .4s;
        width: 100%;

        &:hover {
          background-color: #1a71b417;
        }
      }
    }
  }
</style>
